import React from "react";
import { Check } from 'lucide-react';

export function Checkbox({ checked = false, onClick, disabled, className = "" }) {

    return (
        <div className="oct_checkbox-wrapper-v2">
            <input 
                type="checkbox"
                className={`oct_checkbox-v2 ${className}`}
                checked={checked}
                disabled={disabled}
                onChange={() => onClick && onClick(!checked)}
                aria-label="checkbox"
            />
            {checked && (
                <Check className="oct_checkbox-icon-v2" />
            )}
        </div>
    )
}
